import { axiosPrivate } from "api/axiosCore";
import axios from "axios";

const basic_url = process.env.REACT_APP_BASE_URL + "api/holidays/";

export const serviceGetHolidays = async (token, query, page, limit = 10) => {
  try {
    const queryData = query ? "&q=" + query : "";
    const response = await axios.get(basic_url + `?order=ASC&take=${limit}&page=${page || 1}` + queryData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'AccessControl-Allow-Origin' : 'http://localhost:3001',
      }
    });
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePostHoliday = async (token, data) => {
  try {
    const response = await axios.post(basic_url, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'AccessControl-Allow-Origin' : 'http://localhost:3001',
      }
    });

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const servicePutHoliday = async (id, token, data) => {
  try {

    const response = await axios.put(basic_url + id, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'AccessControl-Allow-Origin' : 'http://localhost:3001',
      }
    });

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceDeleteHoliday = async (id, token) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const response = await axiosPrivate.delete(basic_url + id);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
}; 